import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enToolbar from './locales/en/toolbar.json';
import enCanvas from './locales/en/canvas.json';
import enPanels from './locales/en/panels.json';
import enChrome from './locales/en/chrome.json';
import enNotices from './locales/en/notices.json';
import enValidation from './locales/en/validation.json';
import enJourneys from './locales/en/journeys.json';
import enModals from './locales/en/modals.json';
import enAnalytics from './locales/en/analytics.json';
import enGallery from './locales/en/gallery.json';
import enWelcome from './locales/en/welcome.json';
import enHelp from './locales/en/help.json';
import enFiles from './locales/en/files.json';
import enAssistant from './locales/en/assistant.json';
import enKnowledge from './locales/en/knowledge.json';
import deCommon from './locales/de/common.json';
import deToolbar from './locales/de/toolbar.json';
import deCanvas from './locales/de/canvas.json';
import dePanels from './locales/de/panels.json';
import deChrome from './locales/de/chrome.json';
import deNotices from './locales/de/notices.json';
import deValidation from './locales/de/validation.json';
import deJourneys from './locales/de/journeys.json';
import deModals from './locales/de/modals.json';
import deAnalytics from './locales/de/analytics.json';
import deGallery from './locales/de/gallery.json';
import deWelcome from './locales/de/welcome.json';
import deHelp from './locales/de/help.json';
import deFiles from './locales/de/files.json';
import deAssistant from './locales/de/assistant.json';
import deKnowledge from './locales/de/knowledge.json';

// Resources are imported statically — CRA has no build-time i18n story, and
// the whole catalog is small enough that lazy loading buys nothing.
const resources = {
  en: { common: enCommon, toolbar: enToolbar, canvas: enCanvas, panels: enPanels, chrome: enChrome, notices: enNotices, validation: enValidation, journeys: enJourneys, modals: enModals, analytics: enAnalytics, gallery: enGallery, welcome: enWelcome, help: enHelp, files: enFiles, assistant: enAssistant, knowledge: enKnowledge },
  de: { common: deCommon, toolbar: deToolbar, canvas: deCanvas, panels: dePanels, chrome: deChrome, notices: deNotices, validation: deValidation, journeys: deJourneys, modals: deModals, analytics: deAnalytics, gallery: deGallery, welcome: deWelcome, help: deHelp, files: deFiles, assistant: deAssistant, knowledge: deKnowledge },
};

// First visit: follow the browser. Afterwards: the persisted choice.
// Hand-rolled (no detector plugin) — two languages, one rule.
export const detectInitialLanguage = () => {
  try {
    const saved = localStorage.getItem('language');
    if (saved === 'en' || saved === 'de') return saved;
  } catch (e) { /* storage unavailable (private mode) — fall through */ }
  const nav = (typeof navigator !== 'undefined' && navigator.language) || 'en';
  return nav.toLowerCase().startsWith('de') ? 'de' : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    // Synchronous init: resources are bundled, so there is nothing to wait
    // for — and tests rely on `t` returning real strings on first render.
    initImmediate: false,
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false,
  });

// Single write path for changing language: persists, then switches. Owning
// this here (not in a React context) lets the toolbar toggle work without a
// provider and keeps canvas/non-React callers on the same mechanism.
// Keep <html lang> truthful — screen readers pick pronunciation rules from
// it (WCAG 3.1.1) and browsers decide translate-prompts/hyphenation by it.
const syncDocumentLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};
syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export const setAppLanguage = (lang) => {
  try { localStorage.setItem('language', lang); } catch (e) { /* private mode */ }
  i18n.changeLanguage(lang);
};

export default i18n;
